import { BaseClient } from '../BaseClient';
import { EmailAddress, Empty, Int32 } from '../compiled-protos/common';
import type { CustomerAccountSearchRequest } from '../compiled-protos/customeracc';
import { CustomerAccountCredential, PasswordResetRequest } from '../compiled-protos/customeracc';
import { CustomerAccountServiceClient as CustomerAccountProtoClient } from '../compiled-protos/customeracc.client'

export class CustomerAccountClient extends BaseClient {
  self: CustomerAccountProtoClient;

  constructor(host: string, userID?: number) {
    super(host, userID);
    this.self = new CustomerAccountProtoClient(this.transport);
  }

  /**
   *
   * @throws {Error}
   */
  public async SignUp({ email, password }: { email: string, password: string }) {
    const credentials = CustomerAccountCredential.create({
      email,
      password,
    })
    return await this.self.signUp(credentials)
  }

  /**
   *
   * @throws {Error}
   */
  public async SignIn({ email, password }: { email: string, password: string }) {
    const credentials = CustomerAccountCredential.create({
      email,
      password,
    })
    return await this.self.signIn(credentials)
  }

  public async GetAccountByEmail({ email, authToken }: { email: string, authToken: string }) {
    const request = EmailAddress.create({ email })
    return await this.self.getByEmail(request, this.getMetaData(authToken))
  }

  public async RefreshTokens({ authToken, refreshToken }: { authToken: string, refreshToken: string }) {
    const metadata = this.getMetaDataWithoutCache(authToken)
    metadata.meta["refresh_token"] = refreshToken
    return this.self.refreshToken(Empty.create(), metadata)
  }

  public async RequestPasswordReset({ email }: { email: string }) {
    const request = EmailAddress.create({ email })
    return await this.self.requestPasswordReset(request)
  }

  public async ResetPassword({ token, password }: { token: string, password: string }) {
    const request = PasswordResetRequest.create({
      token,
      password,
    })
    return await this.self.resetPassword(request)
  }

  public async GetByLegacyAccountId(legacyAccountId: number) {
    const request = Int32.create({ value: legacyAccountId });
    return await this.self.getByLegacyAccountId(request, this.getMetaData()).response;
  }

  public async BatchGet(req: CustomerAccountSearchRequest) {
    return await this.self.batchGet(req, this.getMetaData()).response;
  }
}
